import {Yii} from "libraries/interfaces/Yii";

/**
 * CARD OPTION LABELS TRANSLATED
 */
export const CARD_OPTION_LABELS: { [key: string]: string } = {
    error: Yii.t('wui-sasha-js', 'Le formulaire contient une ou plusieurs erreurs'),
    submit: Yii.t('wui-sasha-js', 'Rechercher'),
}